import React, { useEffect, useRef, useState } from "react";
import { MainWrapper } from "../../component/MainWrapper";
import { FormattedMessage, useIntl } from "react-intl";
import { Link } from "react-router-dom";
import DropDown from "sr/helpers/ui-components/DropDown.tsx";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { CandidateStatus } from "sr/i18n/messages/setting";
import ContentWithSpinner from "sr/layout/common/ContentWithSpiner";
import getLabelByValue from "sr/helpers/functions/getLabelByValue";
import { updateContractor } from "sr/utils/api/company/workorder/updateContractor";
import { SuccessMessage } from "sr/helpers/functions/SuccessMessage";
import { WhiteBtn } from "../component/WhiteBtn";
import { useAuth } from "app/pages/module/auth";
import { Pagination } from "app/pages/component/Pagination";
import { fetchContractor } from "sr/helpers/apiFunctions/contractor/fetchContractor";
import { fetchSupervisor } from "sr/redux/reducers/supervisor";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "sr/redux/store";
import { fetchCustomerLocations } from "sr/helpers/apiFunctions/fetchCustomerLocations";
import { ModelWrapperWithButton } from "../../component/ModelWrapperWithButton";
import { ModelWrapper } from "../../component/ModelWrapper";
import Form from "./components/Form";
import { AddressDisplay } from "sr/helpers/functions/AddressDisplay";
import { resendContractor } from "sr/utils/api/company/workorder/resendContractor";
import { Spinner } from "sr/helpers";
import { DeleteConfirmation } from "app/pages/component/DeleteConfirmation";
import { Checkbox } from "sr/helpers";
import {
  BACKGROUND_CHECK_STATUSES,
  STRIPE_ONBOARDING_STATUSES,
} from "sr/constants/common";
import { InputNumberFormat } from "sr/helpers/functions/InputNumberFormat";
import { getUserFullProfile } from "sr/utils/api/user/user";

export const Contractor = () => {
  const intl = useIntl();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [location, setLocation] = useState();
  const [data, setdata] = useState([]);
  const [userId, setuserId] = useState<string>();
  const [loader, setLoader] = useState(true);
  const [totalPage, settotalPage] = useState<number>(0);
  const { userType } = useAuth();
  const dispatch = useDispatch<AppDispatch>();
  const [modalShow, setShowModal] = useState(false);
  const [id, setId] = useState<string>();
  const supervisorData = useSelector((item: any) => item?.supervisor?.data);
  const [customerLocationId, setCustomerLocationId] = useState<any>();
  const [customerLocations, setCustomerLocations] = useState([]);
  const [resendLoader, setResendLoader] = useState(false);
  const [sortBy, setSortBy] = useState("first_name");
  const childRef: any = useRef();
  const [showDelete, setShowDelete] = useState(false);
  const [deleteId, setDeleteId] = useState<string>("");
  const [deleteName, setDeleteName] = useState<string>("");
  const [showInactive, setShowInactive] = useState(false);
  const [showOnboardingChecklist, setShowOnboardingChecklist] = useState(false);
  const [profileLoading, setProfileLoading] = useState(true);
  useEffect(() => {
    const { user_id } = getUserDetails();
    setuserId(user_id);
  }, []);
  useEffect(() => {
    const loadProfile = async () => {
      setProfileLoading(true);
      const response = await getUserFullProfile();
      const profile = response?.data?.user_type_detail;
      setShowOnboardingChecklist(
          profile?.isAllowedOnBordingSubmission === true,
      );
      setProfileLoading(false);
    };
    loadProfile();
  }, []);
  useEffect(() => {
    const loadCustomerLocation = async () => {
      await fetchCustomerLocations(
        userType === "supervisor"
          ? {
              customerLocationId: customerLocationId,
              setCustomerLocations: setCustomerLocations,
            }
          : {
              customerLocationId: customerLocationId,
              setCustomerLocations: setCustomerLocations,
              companyId: userId,
              alldata: true,
            },
      );
    };
    if (userId && userType) {
      if (userType === "supervisor") {
        if (customerLocationId) {
          loadCustomerLocation();
        }
      } else {
        loadCustomerLocation();
      }
    }
  }, [userId, userType, customerLocationId]);
  useEffect(() => {
    if (userId && userType === "supervisor") {
      if (!supervisorData) {
        dispatch(fetchSupervisor({ id: userId }));
      }
    }
  }, [userId, userType, dispatch]);
  const fetchAllLocation = async (companyId) => {
    const data = await fetchCustomerLocations({
      userType: userType,
      companyId: companyId,
      alldata: true,
    });
    setCustomerLocationId(data?.map((item) => item?.id)?.join());
  };

  useEffect(() => {
    if (supervisorData) {
      const id: Array<any> = supervisorData?.customer_location_ids?.map(
        (item) => item?._id,
      );
      if (id?.length > 0) {
        setCustomerLocationId(id?.join());
      } else {
        fetchAllLocation(supervisorData?.company_id?._id);
      }
    }
  }, [supervisorData]);
  const loadContractor = async () => {
    await fetchContractor({
      userType: userType,
      sortBy: sortBy,
      setTotalPage: settotalPage,
      userId: userId,
      supervisor_id: supervisorData?.id,
      customerLocationId: customerLocationId,
      setData: setdata,
      setLoader: setLoader,
      page: page,
      limit: limit,
      location: location,
      status: showInactive ? "deleted" : undefined,
    });
  };
  useEffect(() => {
    if (userId && userType) {
      if (userType === "supervisor") {
        if (customerLocationId) {
          loadContractor();
        }
      } else {
        loadContractor();
      }
    }
  }, [
    userId,
    sortBy,
    customerLocationId,
    userType,
    location,
    page,
    showInactive,
  ]);

  const HandleDeleteContractor = (id, name) => {
    setDeleteId(id);
    setDeleteName(name);
    setShowDelete(true);
  };
  const ConfirmDelete = async () => {
    const payLoad = {
      id: deleteId,
      status: "deleted",
    };
    const res = await updateContractor(payLoad);
    if (res?.success === true) {
      SuccessMessage("API.SUCCESS.CONTRACTOR.INACTIVE");
      setdata(data?.filter((item) => item?.id !== res?.data?.id));
      setShowDelete(false);
      setDeleteId("");
      setDeleteName("");
    }
  };
  const HandleReactivate = async (id) => {
    const payLoad = {
      id: id,
      status: "active",
    };
    const res = await updateContractor(payLoad);
    if (res?.success === true) {
      SuccessMessage("Contractor reactivated successfully");
      loadContractor();
    }
  };
  const HandleEdit = (id) => {
    setShowModal(true);
    setId(id);
  };
  const onCheckModel = () => {
    setShowModal(false);
    setId("");
  };
  const HandleEditSave = () => {
    if (childRef.current && childRef.current.submitForm) {
      childRef.current.submitForm();
    }
  };
  const dataAddedHandle = (data) => {
    if (data === true) {
      setShowModal(false);
      loadContractor();
    }
  };
  const HandleResend = async (id) => {
    setResendLoader(true);
    try {
      const res = await resendContractor({ id: id });
      if (res?.success) {
        setResendLoader(false);
      } else {
        setResendLoader(false);
      }
    } catch (e) {
      setResendLoader(false);
    }
  };
  return (
    <MainWrapper>
      <div className="py-3">
        <ContentWithSpinner loader={loader} height="h-screen">
          <div className="mb-2">
            <h1 className="text-2xl  border-r border-neutral-200 pr-4">
              <FormattedMessage
                id="RECRUITER.SIDEBAR.MENU.CONTRACTOR"
                defaultMessage="Contractors"
              />
            </h1>
          </div>
          <div className="flex justify-between">
            <div className="flex  space-x-4 items-center">
              <DropDown
                labelClass="text-base"
                value={location}
                label={intl.formatMessage({
                  id: "RECRUITER.WORKORDER.FILTER.LOCATION",
                  defaultMessage: "Location",
                })}
                dropdowndiv="mt-1"
                onChange={(e) => setLocation(e.target.value)}
                className="rounded-lg"
              >
                <option value="">
                  <FormattedMessage
                    id="RECRUITER.WORKORDER.FILTER.SELECT.LOCATION"
                    defaultMessage="Select Location"
                  />
                </option>
                {(Array.isArray(customerLocations)
                  ? customerLocations
                  : [customerLocations]
                )?.map((item, index) => (
                  <option key={index} value={item?.id}>
                    {AddressDisplay(item?.address)}
                  </option>
                ))}
              </DropDown>
              <div className="flex  space-x-4">
                <DropDown
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                  dropdowndiv="mt-1 min-w-48"
                  label={intl.formatMessage({
                    id: "RECRUITER.POSTED.JOB.FILTER.SORTBY.TITLE",
                    defaultMessage: "Sort By:",
                  })}
                  className="rounded-lg"
                  labelClass={"text-base"}
                >
                  <option>
                    {" "}
                    <FormattedMessage
                      id="RECRUITER.POSTED.JOB.FILTER.SORTBY.TYPE"
                      defaultMessage="Job Title"
                    />{" "}
                  </option>
                  <option value={"first_name"}> A - Z </option>
                  <option value={"-first_name"}> Z - A </option>
                </DropDown>
              </div>
              <div className="flex w-1/6 mt-8 items-center space-x-2">
                <Checkbox
                  id="showInactive"
                  name="showInactive"
                  checked={showInactive}
                  onChange={() => setShowInactive(!showInactive)}
                  label="Inactive"
                />
              </div>
            </div>
            {(userType === "company" ||
              (userType === "supervisor" &&
                supervisorData?.access?.contractor_management
                  ?.add_contractor)) && (
              <div className="flex">
                <Link to="/new-contractor">
                  <WhiteBtn
                    mainClass="mt-5"
                    title={
                      <FormattedMessage
                        id="RECRUITER.WORK.ORDER.CONTRACTOR.ADD.BTN."
                        defaultMessage="Add Contractor"
                      />
                    }
                  ></WhiteBtn>
                </Link>
              </div>
            )}
          </div>
          <div className="overflow-x-auto mt-4 rounded-[20px]">
            <table className="w-full text-left condidate-table">
              <thead className="bg-[#FAF9F8] border-collapse border-b border-neutral-200 capitalize">
                <tr>
                  <th scope="col" className="px-6 py-4 text-base ">
                    <FormattedMessage
                      id="RECRUITER.CONTRACTOR.TABLE.COL.NAME"
                      defaultMessage="Name"
                    />
                  </th>
                  <th scope="col" className="px-6 py-4 text-base ">
                    <FormattedMessage
                      id="RECRUITER.CONTRACTOR.TABLE.COL.MOBILENO"
                      defaultMessage="Mobile No"
                    />
                  </th>
                  <th scope="col" className="px-6 py-4 text-base ">
                    <FormattedMessage
                      id="RECRUITER.CONTRACTOR.TABLE.COL.ADDRESS"
                      defaultMessage="Address"
                    />
                  </th>
                  <th scope="col" className="px-6 py-4 text-base ">
                    <FormattedMessage
                      id="RECRUITER.CONTRACTOR.TABLE.COL.STATUS"
                      defaultMessage="Status"
                    />
                  </th>
                  {(showOnboardingChecklist || profileLoading) && (
                    <th scope="col" className="px-6 py-4 text-base ">
                      Onboarding Status
                    </th>
                  )}
                  <th scope="col" className="px-6 py-4 text-base ">
                    <FormattedMessage
                      id="RECRUITER.CONTRACTOR.TABLE.COL.ACTION"
                      defaultMessage="Action"
                    />
                  </th>
                </tr>
              </thead>
              <tbody>
                {data?.map((item, index) => (
                  <tr className="bg-white border-b  hover:bg-gray-50">
                    <th
                      scope="row"
                      className="px-6 py-4 font-medium text-gray-900 "
                    >
                      <Link to={`/contractor-details/${item?.id}`}>
                        <div className="w-auto text-base cursor-pointer flex gap-2">
                          {item?.first_name} {item?.last_name}
                          {((item?.cleaner_id?.backgroundCheckStatus !=
                            undefined &&
                            [
                              BACKGROUND_CHECK_STATUSES.CLEAR,
                              BACKGROUND_CHECK_STATUSES.CONSIDER,
                              BACKGROUND_CHECK_STATUSES.EXPIRED,
                            ].indexOf(
                              item?.cleaner_id?.backgroundCheckStatus,
                            ) !== -1) ||
                            item?.cleaner_id?.stripe_customer_model
                              ?.stripe_onboarding_status ===
                              STRIPE_ONBOARDING_STATUSES.SUCCESS) && (
                              <span className="relative group w-6 h-6 inline">
                                <img
                                  src="/media/icons/checkr-badge-pink-NB.png"
                                  alt="Background check verified"
                                  className="w-6 h-6"
                                />

                                {/* Tooltip */}
                                <div className="absolute left-0 top-full pt-2 w-52 hidden group-hover:block z-50">
                                  <div className="bg-gray-900 text-white text-xs rounded-lg p-3 shadow-lg leading-relaxed">
                                    Background Check Verified User
                                  </div>
                                </div>
                              </span>
                            )}
                        </div>
                      </Link>
                    </th>
                    <td className="px-6 py-4">
                      {InputNumberFormat(item?.mobile_number)}
                    </td>
                    <td className="px-6 py-4">
                      {item?.address?.address_line_1 ||
                        item?.cleaner_id?.address?.address_line_1}{" "}
                      {item?.address?.address_line_2 ||
                        item?.cleaner_id?.address?.address_line_2}{" "}
                      {item?.address?.city || item?.cleaner_id?.address?.city}
                    </td>
                    <td className="px-6 py-4">
                      {getLabelByValue(item?.status, CandidateStatus)}
                    </td>
                    {(showOnboardingChecklist || profileLoading) && (
                      <td className="px-6 py-4 capitalize">
                        {profileLoading ? (
                          <div className="animate-pulse bg-gray-200 h-4 w-20 rounded"></div>
                        ) : item?.onBoardingStatus ? (
                          item.onBoardingStatus
                        ) : (
                          <div className="animate-pulse bg-gray-200 h-4 w-20 rounded"></div>
                        )}
                      </td>
                    )}

                    <td className="px-6 py-4">
                      <div className="flex items-center space-x-3">
                        {item?.status === "pending" && (
                          <button
                            onClick={() => HandleResend(item?.id)}
                            className="rounded-lg bg-[#ff39b3] font-bold px-5 py-3  text-white cursor-pointer hover:bg-navy"
                          >
                            {resendLoader ? (
                              <Spinner className="flex w-full justify-center" />
                            ) : (
                              <FormattedMessage id="RECRUITER.SUPERVISOR.RESEND.EMAIL"></FormattedMessage>
                            )}
                          </button>
                        )}
                        {item?.status === "deleted" ? (
                          <button
                            onClick={() => HandleReactivate(item?.id)}
                            className="rounded-lg bg-[#ff39b3] font-bold px-5 py-3  text-white cursor-pointer hover:bg-navy"
                          >
                            Reactivate
                          </button>
                        ) : (
                          <div className="border border-neutral-200 rounded-lg inline-flex w-auto items-center">
                            {(userType === "company" ||
                              (userType === "supervisor" &&
                                supervisorData?.access?.contractor_management
                                  ?.update_contractor)) && (
                              <Link to={`/contractor-details/${item?.id}`}>
                                <div className="py-1.5 px-2 border-r border-neutral-200 cursor-pointer  hover:text-[#0078ae] hover:rounded-l-lg hover:border-2 hover:border-[#0078ae] hover:bg-[#d6f2ff]">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={1.5}
                                    stroke="currentColor"
                                    className="w-8 h-6"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125"
                                    />
                                  </svg>
                                </div>
                              </Link>
                            )}
                            {(userType === "company" ||
                              (userType === "supervisor" &&
                                supervisorData?.access?.contractor_management
                                  ?.delete_contractor)) && (
                              <div
                                onClick={() =>
                                  HandleDeleteContractor(
                                    item?.id,
                                    `${item?.first_name} ${item?.last_name}`,
                                  )
                                }
                                className="py-1.5 px-2 cursor-pointer hover:text-[#a9252b]   hover:border-2 hover:rounded-r-lg hover:border-[#f76266] hover:bg-[#FEEEEF]"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  strokeWidth={1.5}
                                  stroke="currentColor"
                                  className="w-8 h-6"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"
                                  />
                                </svg>
                                <span className="absolute z-10 top-10 scale-0 rounded bg-gray-800 p-2 text-xs text-white group-hover:scale-100">
                                  <FormattedMessage
                                    id="RECRUITER.CONTRACTOR.TABLE.COL.ACTION.DELETE"
                                    defaultMessage="Delete Contractor"
                                  />
                                </span>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <Pagination page={page} totalPage={totalPage} setPage={setPage} />
          </div>
        </ContentWithSpinner>
      </div>
      <ModelWrapperWithButton
        showModal={modalShow}
        onCheckModel={onCheckModel}
        Save={HandleEditSave}
      >
        <Form
          type="popup"
          id={id}
          ref={childRef}
          dataAddedHandle={dataAddedHandle}
        />
      </ModelWrapperWithButton>
      {showDelete && (
        <ModelWrapper
          rounded="rounded-[10px]"
          background="bg-[#00000099]"
          position="fixed"
          opacity="opacity-100"
          topPosition="top-[10%]"
          rightPosition="inset-0"
          width="w-[50%] mx-auto"
          showModal={showDelete}
          HandleModelByProps={() => {
            setShowDelete(false);
            setDeleteId("");
            setDeleteName("");
          }}
        >
          <DeleteConfirmation
            onCancel={() => {
              setShowDelete(false);
              setDeleteId("");
              setDeleteName("");
            }}
            onDelete={ConfirmDelete}
            text={`Are you sure you want to make ${deleteName} inactive?`}
          />
        </ModelWrapper>
      )}
    </MainWrapper>
  );
};
